/**
 * No-op/Pass-through implementation of ISerializationHandler
 * Used when values are already serializable and they don't need this extra step
 */ export class PassThroughSerializationHandler {
    toSerializable(key, value) {
        return value;
    }
    fromSerializable(key, serializableValue) {
        return serializableValue;
    }
}
